"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageAnunciosRevisor = exports.ListadoRevisor = exports.PageAnuncios = exports.AnunciosData = exports.FetchAnuncios = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var tempDate = new Date();
var year = tempDate.getFullYear();
var mes = (tempDate.getMonth() + 1);
var day = tempDate.getDate();
if (mes >= 10 && day >= 10) {
    var date = year + '-' + mes + '-' + day;
}
else if (mes < 10 && day < 10) {
    var date = year + '-' + '0' + mes + '-' + '0' + day;
}
else if (mes < 10) {
    var date = year + '-' + '0' + mes + '-' + day;
}
else {
    var date = year + '-' + mes + '-' + '0' + day;
}
var FetchAnuncios = /** @class */ (function (_super) {
    __extends(FetchAnuncios, _super);
    function FetchAnuncios(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { dtoList: [], loading: true };
        fetch('http://localhost:3368/api/Catalog/Anuncios')
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ dtoList: data, loading: false });
        });
        // This binding is necessary to make "this" work in the callback  
        _this.handleDelete = _this.handleDelete.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        return _this;
    }
    FetchAnuncios.prototype.render = function () {
        var contents = this.state.loading
            ? React.createElement("p", null,
                React.createElement("em", null, "Loading..."))
            : this.renderAnunciosTable(this.state.dtoList);
        return React.createElement("div", null,
            React.createElement("h1", null, "Anuncios Data"),
            React.createElement("p", null, "This component demonstrates fetching Employee data from the server."),
            React.createElement("p", null,
                React.createElement(react_router_dom_1.Link, { to: "/add-anuncios" }, "Create New")),
            contents);
    };
    // Handle Delete request for an employee  
    FetchAnuncios.prototype.handleDelete = function (id) {
        var _this = this;
        //if (!confirm("Do you want to delete employee with Id: " + id))
        if (id == 0)
            return;
        else {
            fetch('http://localhost:5220/api/Catalog/Anuncios/' + id, {
                method: 'delete'
            }).then(function (data) {
                _this.setState({
                    dtoList: _this.state.dtoList.filter(function (rec) {
                        return (rec.idAnuncio != id);
                    })
                });
            });
        }
    };
    FetchAnuncios.prototype.handleEdit = function (id) {
        this.props.history.push("/anuncios/edit/" + id);
    };
    // Returns the HTML table to the render() method.  
    FetchAnuncios.prototype.renderAnunciosTable = function (dtoList) {
        var _this = this;
        return React.createElement("table", { className: 'table' },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null),
                    React.createElement("th", null, "IdAnuncio"),
                    React.createElement("th", null, "IdCategoria"),
                    React.createElement("th", null, "IdUnidad"),
                    React.createElement("th", null, "TxtTitulo"),
                    React.createElement("th", null, "TxTexto"),
                    React.createElement("th", null, "TxImagen"),
                    React.createElement("th", null, "DtPublicacion"),
                    React.createElement("th", null, "DtVigencia"),
                    React.createElement("th", null, "BdPublicarAutomatico"),
                    React.createElement("th", null, "TxUrl"),
                    React.createElement("th", null, "TxLugar"),
                    React.createElement("th", null, "DtInicio"),
                    React.createElement("th", null, "DtFin"),
                    React.createElement("th", null, "BdTipo"),
                    React.createElement("th", null, "BdAmbito"),
                    React.createElement("th", null, "DtUltimoCambio"))),
            React.createElement("tbody", null, dtoList.map(function (dto) {
                return React.createElement("tr", { key: dto.idAnuncio },
                    React.createElement("td", null),
                    React.createElement("td", null, dto.idAnuncio),
                    React.createElement("td", null, dto.txTitulo),
                    React.createElement("td", null, dto.txTexto),
                    React.createElement("td", null, dto.txImagen),
                    React.createElement("td", null, dto.dtPublicacion),
                    React.createElement("td", null, dto.dtVigencia),
                    React.createElement("td", null, dto.bdPublicarAutomatico ? "Sí" : "No"),
                    React.createElement("td", null, dto.txUrl),
                    React.createElement("td", null, dto.txLugar),
                    React.createElement("td", null, dto.dtInicio),
                    React.createElement("td", null, dto.dtFin),
                    React.createElement("td", null, dto.bdTipo),
                    React.createElement("td", null, dto.bdAmbito),
                    React.createElement("td", null, dto.dtUltimoCambio),
                    React.createElement("td", null,
                        React.createElement("a", { className: "action", onClick: function (id) { return _this.handleEdit(dto.idAnuncio); } }, "Edit"),
                        "  |",
                        React.createElement("a", { className: "action", onClick: function (id) { return _this.handleDelete(dto.idAnuncio); } }, "Delete")));
            })));
    };
    return FetchAnuncios;
}(React.Component));
exports.FetchAnuncios = FetchAnuncios;
var AnunciosData = /** @class */ (function () {
    function AnunciosData() {
        this.idAnuncio = 0;
        this.idCategoria = 28;
        this.idArea = 23;
        this.dtEnvio = "";
        this.txTitulo = "";
        this.txTexto = "";
        this.txImagen = "";
        this.dtPublicacion = "";
        this.dtVigencia = "";
        this.bdPublicarAutomatico = false;
        this.bdIsReiterativo = false;
        this.txUrl = "";
        this.txLugar = "";
        this.dtInicio = "";
        this.dtFin = "";
        this.bdTipo = "";
        this.bdEstado = "";
        this.bdEstadoRegistro = false;
        this.bdAmbito = "";
        this.dtUltimoCambio = "";
        this.rowVersion = "";
        this.softDeleted = false;
        this.visited = false;
        this.interacciones = 0;
        this.audiencias = [];
        // idCategoriaNavigation: number = 0;
        // idUnidadNavigation: number = 0;    
    }
    return AnunciosData;
}());
exports.AnunciosData = AnunciosData;
var PageAnuncios = /** @class */ (function () {
    function PageAnuncios() {
        this.pageNumber = 0;
        this.pageSize = 0;
        this.firstPage = "";
        this.lastPage = "";
        this.totalPages = 0;
        this.totalRecords = 0;
        this.nextPage = "";
        this.previousPage = "";
        this.succeeded = false;
        this.errors = "";
        this.message = "";
    }
    return PageAnuncios;
}());
exports.PageAnuncios = PageAnuncios;
var ListadoRevisor = /** @class */ (function () {
    function ListadoRevisor() {
        this.idAnuncio = 0;
        this.dtEnvio = "";
        this.dtPublicacion = "";
        this.txTitulo = "";
        this.bdTipo = "";
        this.bdEstado = "";
        this.unidad = "";
        this.area = "";
    }
    return ListadoRevisor;
}());
exports.ListadoRevisor = ListadoRevisor;
var PageAnunciosRevisor = /** @class */ (function () {
    function PageAnunciosRevisor() {
        this.pageNumber = 0;
        this.pageSize = 0;
        this.firstPage = "";
        this.lastPage = "";
        this.totalPages = 0;
        this.totalRecords = 0;
        this.nextPage = "";
        this.previousPage = "";
        this.succeeded = false;
        this.errors = "";
        this.message = "";
    }
    return PageAnunciosRevisor;
}());
exports.PageAnunciosRevisor = PageAnunciosRevisor;
//# sourceMappingURL=FetchAnuncios.js.map